import React from "react";
import {motion} from "framer-motion";

const GetStarted = () => {
  return (
    <div className="section with-background-video wf-section">
      <div className="max-width-medium-640px">
        <div className="content-block padded">
          <motion.div 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="text-style-all-caps">
            Getting Started
          </motion.div>
          <motion.h1 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge">How To Get $CLDX</motion.h1>
          <motion.p 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="opacity-90">
            Cloudax (CLDX) is the native token of the Cloudax blockchain. There
            would be a private and public sale on cloudax launchpad. Additional
            IDO would be done on partner Launchpads. Private sale Participants
            would be randomly selected from our whitelist event held on our
            telegram. The public sale would be based on FCFS (First Come, First
            Serve). Our sale method focuses on fairness for the entire
            community.
          </motion.p>
          <div className="button-group">
            <a
              href="https://cloudax.medium.com/cloudax-presale-buying-cloudax-at-discount-50fc041a21e"
              target="_blank"
              className="button w-button"
            >
              Learn More
            </a>
            <a
              href="https://launchpad.cloudax.io/"
              target="_blank"
              className="button secondary w-button"
            >
              <span className="secondary-button-text">Join Presale</span>
            </a>
          </div>
        </div>
      </div>
      <div
        data-poster-url="#"
        data-video-urls="videos/promo.mp4,videos/promo.webm"
        data-autoplay="true"
        data-loop="true"
        data-wf-ignore="true"
        className="background-video w-background-video w-background-video-atom"
      >
        <video
          id="e5e7074b-9e12-8f5e-e28e-86fc48c01a47-video"
          autoPlay={true}
          muted={true}
          loop={true}
          style={{ backgroundImage: 'url("#")' }}
          playsInline=""
          data-wf-ignore="true"
          data-object-fit="cover"
        >
          <source src="videos/cloudax_color_gradient.mp4" data-wf-ignore="true" />
          <source src="videos/promo.webm" data-wf-ignore="true" />
        </video>
      </div>
    </div>
  );
};

export default GetStarted;
